import type { ExternalTableSchema } from '@packages/table-builder';

export const roleMappingTable: ExternalTableSchema = {
  metadata: {
    title: 'Role Mapping',
    entity: 'RoleMapping',
    description: 'Map roles between source and destination companies.',
  },

  dataSource: {
    endpoint: '/api/customer/api/v2/customer-success/allowed-role-mapping',
    method: 'GET',
    rowIdField: 'companyId',
    itemsTransformId: 'role-mapping',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'destinationRoleName',
      header: 'Destination Role',
      type: 'text',
      width: 200,
      align: 'left',
    },
    {
      field: 'destinationCompanyName',
      header: 'Destination Company',
      type: 'text',
      width: 200,
      align: 'left',
    },
    {
      field: 'sourceCompanyName',
      header: 'Source Company',
      type: 'text',
      width: 200,
      align: 'left',
    },
    {
      field: 'sourceRoleName',
      header: 'Source Role',
      type: 'text',
      width: 200,
      align: 'left',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_ROLE_MAPPING', label: 'View' },
      { id: 'EDIT_ROLE_MAPPING', label: 'Edit' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_ROLE_MAPPING',
        label: 'Create Mapping',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'none', defaultSize: 10 },
    groupBy: {
      fields: ['destinationRoleName'],
      expandMode: 'expanded',
      hideGroupedColumn: false,
    },
  },
};
